var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 6.66927H1.3335M7.3335 9.33594H4.00016M1.3335 5.46927L1.3335 10.5359C1.3335 11.2827 1.3335 11.656 1.47882 11.9413C1.60665 12.1921 1.81063 12.3961 2.06151 12.5239C2.34672 12.6693 2.72009 12.6693 3.46683 12.6693L12.5335 12.6693C13.2802 12.6693 13.6536 12.6693 13.9388 12.5239C14.1897 12.3961 14.3937 12.1921 14.5215 11.9413C14.6668 11.656 14.6668 11.2827 14.6668 10.5359V5.46927C14.6668 4.72253 14.6668 4.34917 14.5215 4.06395C14.3937 3.81307 14.1897 3.60909 13.9388 3.48126C13.6536 3.33594 13.2802 3.33594 12.5335 3.33594L3.46683 3.33594C2.72009 3.33594 2.34672 3.33594 2.06151 3.48126C1.81063 3.60909 1.60665 3.81307 1.47882 4.06395C1.3335 4.34917 1.3335 4.72253 1.3335 5.46927Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard02);
export default __webpack_public_path__ + "static/media/credit-card-02.ae75d7275bce1a4084e7e678904a2003.svg";
export { ForwardRef as ReactComponent };